<template>
  <button
    type="button"
    :disabled="disabled || loading"
    class="inline-flex items-center rounded-sm p-1 transition-colors duration-150 ease-in-out hover:bg-black/5 disabled:cursor-default disabled:opacity-50 disabled:hover:bg-transparent"
    :class="{
      'ring-2 ring-blue-600': active,
      '-my-1': tighten,
    }"
  >
    <BaseSpinner v-if="loading" size="md" />
    <svgicon v-if="!loading" v-tooltip="title" :name="icon" :fill="fill" :size="size" />
  </button>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "md",
      validator(value) {
        return ["xs", "sm", "md", "lg"].includes(value);
      },
    },

    icon: String,
    title: String,
    loading: Boolean,
    fill: Boolean,
    active: Boolean,
    tighten: Boolean,
    disabled: Boolean,
  },

  computed: {},
};
</script>
